import { SHOW_REPORT_PROBLEM_VIEW } from '.';

export const showReportProblem = active => dispatch => {
  dispatch({
    type: SHOW_REPORT_PROBLEM_VIEW,
    payload: { active },
  });
};
